
import React, { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import "./Configuracoes2FAcl.css";

const Configuracoes2FA = () => {
  const [qrCode, setQrCode] = useState("");
  const [secret, setSecret] = useState("");
  const [backupCodes, setBackupCodes] = useState([]);
  const [token2FA, setToken2FA] = useState("");
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [processando, setProcessando] = useState(false);
  const [mostrarSecret, setMostrarSecret] = useState(false);
  const [mostrarModalDesativar, setMostrarModalDesativar] =
    useState(false);
  const [tokenDesativar, setTokenDesativar] = useState("");
  const [copiado, setCopiado] = useState(false);

  const navigate = useNavigate();

  const limparMensagens = () => {
    setErro("");
    setSucesso("");
  };

  const limparConfiguracao = () => {
    setQrCode("");
    setSecret("");
    setBackupCodes([]);
    setToken2FA("");
    setMostrarSecret(false);
  };

  const obterEmail = () => {
    const email = sessionStorage.getItem("email");

    if (!email) {
      setErro("Sua sessão não foi encontrada. Faça login novamente.");
      return null;
    }

    return email;
  };

  const check2FAStatus = useCallback(async () => {
    setLoading(true);
    setErro("");

    try {
      const email = sessionStorage.getItem("email");

      if (!email) {
        setErro("Sua sessão não foi encontrada. Faça login novamente.");
        return;
      }

      const response = await api.get("/check-2fa-status/cl13nt", {
        params: { email },
      });

      setIs2FAEnabled(Boolean(response.data.two_factor_enabled));
    } catch (err) {
      console.error("Erro ao verificar status do 2FA:", err);
      setErro(
        err.response?.data?.message ||
          "Não foi possível verificar o status da autenticação."
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check2FAStatus();
  }, [check2FAStatus]);

  const handleSetup2FA = async () => {
    limparMensagens();

    const email = obterEmail();
    if (!email) return;

    setProcessando(true);

    try {
      const checkResponse = await api.get("/check-2fa-status/cl13nt", {
        params: { email },
      });

      if (checkResponse.data.two_factor_enabled) {
        setIs2FAEnabled(true);
        setErro(
          "A autenticação em duas etapas já está habilitada."
        );
        return;
      }

      const response = await api.post("/setup-2fa/cl13nt", {
        email,
      });

      if (response.status === 200) {
        setQrCode(response.data.qr_code || "");
        setSecret(response.data.secret || "");
        setBackupCodes(response.data.backup_codes || []);
        setToken2FA("");
        setSucesso(
          "Escaneie o QR Code no aplicativo autenticador e informe o código gerado."
        );
      }
    } catch (err) {
      console.error("Erro ao configurar 2FA:", err);
      setErro(
        err.response?.data?.message ||
          "Não foi possível iniciar a configuração do 2FA."
      );
    } finally {
      setProcessando(false);
    }
  };

  const handleEnable2FA = async (e) => {
    e.preventDefault();
    limparMensagens();

    const email = obterEmail();
    if (!email) return;

    if (!token2FA.trim()) {
      setErro("Digite o código gerado pelo aplicativo autenticador.");
      return;
    }

    setProcessando(true);

    try {
      const response = await api.post("/enable-2fa/cl13nt", {
        email,
        token_2fa: token2FA.trim(),
      });

      if (response.status === 200) {
        setIs2FAEnabled(true);
        limparConfiguracao();
        setSucesso("Autenticação em duas etapas habilitada com sucesso!");
      }
    } catch (err) {
      console.error("Erro ao habilitar 2FA:", err);
      setErro(
        err.response?.data?.message ||
          "Código inválido ou não foi possível habilitar o 2FA."
      );
    } finally {
      setProcessando(false);
    }
  };

  const abrirModalDesativar = () => {
    limparMensagens();
    setTokenDesativar("");
    setMostrarModalDesativar(true);
  };

  const handleDisable2FA = async (e) => {
    e.preventDefault();
    limparMensagens();

    const email = obterEmail();
    if (!email) return;

    if (!tokenDesativar.trim()) {
      setErro("Informe o código para confirmar a desativação.");
      return;
    }

    setProcessando(true);

    try {
      const response = await api.post("/disable-2fa/cl13nt", {
        email,
        token_2fa: tokenDesativar.trim(),
      });

      if (response.status === 200) {
        setIs2FAEnabled(false);
        setMostrarModalDesativar(false);
        setTokenDesativar("");
        limparConfiguracao();
        setSucesso("Autenticação em duas etapas desabilitada.");
      }
    } catch (err) {
      console.error("Erro ao desabilitar 2FA:", err);
      setErro(
        err.response?.data?.message ||
          "Código inválido ou não foi possível desabilitar o 2FA."
      );
    } finally {
      setProcessando(false);
    }
  };

  const copiarTexto = async (texto) => {
    try {
      await navigator.clipboard.writeText(texto);
      setCopiado(true);
      window.setTimeout(() => setCopiado(false), 2000);
    } catch (err) {
      console.error("Erro ao copiar:", err);
      setErro("Não foi possível copiar automaticamente. Copie o texto manualmente.");
    }
  };

  const cancelarConfiguracao = () => {
    limparConfiguracao();
    limparMensagens();
  };

  return (
    <div className="ca2fa-page">
      <div className="ca2fa-wrapper">
        <button
          type="button"
          className="ca2fa-back"
          onClick={() => navigate(-1)}
        >
          <span aria-hidden="true">←</span>
          Voltar
        </button>

        <header className="ca2fa-header">
          <div className="ca2fa-header-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M12 3 20 6v5c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-3Z"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinejoin="round"
              />
              <path
                d="m9 12 2 2 4-4"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div>
            <span className="ca2fa-eyebrow">SEGURANÇA DA CONTA</span>
            <h1>Autenticação em duas etapas</h1>
            <p>
              Adicione uma camada extra de proteção à sua conta.
            </p>
          </div>
        </header>

        {erro && (
          <div className="ca2fa-alert ca2fa-alert-error" role="alert">
            <span className="ca2fa-alert-icon">!</span>
            <p>{erro}</p>
            <button
              type="button"
              onClick={() => setErro("")}
              aria-label="Fechar mensagem"
            >
              ×
            </button>
          </div>
        )}

        {sucesso && (
          <div
            className="ca2fa-alert ca2fa-alert-success"
            role="status"
          >
            <span className="ca2fa-alert-icon">✓</span>
            <p>{sucesso}</p>
            <button
              type="button"
              onClick={() => setSucesso("")}
              aria-label="Fechar mensagem"
            >
              ×
            </button>
          </div>
        )}

        {loading ? (
          <section className="ca2fa-card ca2fa-loading">
            <span className="ca2fa-spinner" />
            <p>Verificando configurações de segurança...</p>
          </section>
        ) : (
          <>
            <section className="ca2fa-card">
              <div className="ca2fa-card-top">
                <div className="ca2fa-section-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <rect
                      x="5"
                      y="10"
                      width="14"
                      height="11"
                      rx="2"
                      stroke="currentColor"
                      strokeWidth="1.7"
                    />
                    <path
                      d="M8 10V7a4 4 0 0 1 8 0v3"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                    />
                    <circle cx="12" cy="15" r="1.3" fill="currentColor" />
                  </svg>
                </div>

                <div className="ca2fa-card-heading">
                  <h2>Status da proteção</h2>
                  <p>
                    Gerencie a autenticação adicional da sua conta.
                  </p>
                </div>

                <span
                  className={`ca2fa-status ${
                    is2FAEnabled
                      ? "ca2fa-status-active"
                      : "ca2fa-status-inactive"
                  }`}
                >
                  <span className="ca2fa-status-dot" />
                  {is2FAEnabled ? "Ativada" : "Desativada"}
                </span>
              </div>

              <div className="ca2fa-status-content">
                <div>
                  <h3>
                    {is2FAEnabled
                      ? "Sua conta está protegida"
                      : "Proteja sua conta"}
                  </h3>
                  <p>
                    {is2FAEnabled
                      ? "Além da sua senha, será necessário informar um código temporário para confirmar a autenticação, conforme o fluxo de login configurado."
                      : "Use um aplicativo autenticador para gerar códigos temporários e dificultar acessos não autorizados."}
                  </p>
                </div>

                {is2FAEnabled ? (
                  <button
                    type="button"
                    className="ca2fa-button ca2fa-button-danger-outline"
                    onClick={abrirModalDesativar}
                    disabled={processando}
                  >
                    Desabilitar 2FA
                  </button>
                ) : (
                  <button
                    type="button"
                    className="ca2fa-button ca2fa-button-primary"
                    onClick={handleSetup2FA}
                    disabled={processando}
                  >
                    {processando ? (
                      <>
                        <span className="ca2fa-spinner ca2fa-spinner-small" />
                        Preparando...
                      </>
                    ) : (
                      <>
                        <span aria-hidden="true">+</span>
                        Configurar 2FA
                      </>
                    )}
                  </button>
                )}
              </div>
            </section>

            {!is2FAEnabled && !qrCode && (
              <section className="ca2fa-card ca2fa-info-card">
                <h2>Como funciona?</h2>

                <div className="ca2fa-steps">
                  <div className="ca2fa-step">
                    <span className="ca2fa-step-number">1</span>
                    <div>
                      <h3>Configure o autenticador</h3>
                      <p>
                        Gere o QR Code e escaneie com seu aplicativo
                        autenticador.
                      </p>
                    </div>
                  </div>

                  <div className="ca2fa-step">
                    <span className="ca2fa-step-number">2</span>
                    <div>
                      <h3>Confirme sua configuração</h3>
                      <p>
                        Digite o código temporário exibido no aplicativo.
                      </p>
                    </div>
                  </div>

                  <div className="ca2fa-step">
                    <span className="ca2fa-step-number">3</span>
                    <div>
                      <h3>Guarde seus códigos de backup</h3>
                      <p>
                        Eles podem ajudar na recuperação do acesso, de
                        acordo com o suporte implementado no backend.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {qrCode && !is2FAEnabled && (
              <section className="ca2fa-card ca2fa-setup-card">
                <div className="ca2fa-setup-heading">
                  <span className="ca2fa-step-number">1</span>
                  <div>
                    <h2>Configure seu autenticador</h2>
                    <p>
                      Escaneie o QR Code e confirme com o código gerado
                      pelo aplicativo.
                    </p>
                  </div>
                </div>

                <div className="ca2fa-qr-area">
                  <div className="ca2fa-qr-frame">
                    <img
                      src={qrCode}
                      alt="QR Code para configurar autenticação em duas etapas"
                      className="ca2fa-qr-image"
                    />
                  </div>

                  <p className="ca2fa-qr-caption">
                    Abra seu aplicativo autenticador e escaneie este código.
                  </p>
                </div>

                {secret && (
                  <div className="ca2fa-secret-box">
                    <label htmlFor="ca2fa-secret">
                      Ou configure manualmente
                    </label>

                    <div className="ca2fa-secret-row">
                      <code id="ca2fa-secret">
                        {mostrarSecret
                          ? secret
                          : "•".repeat(Math.min(secret.length, 24))}
                      </code>

                      <button
                        type="button"
                        className="ca2fa-icon-button"
                        onClick={() => setMostrarSecret(!mostrarSecret)}
                        aria-label={
                          mostrarSecret
                            ? "Ocultar chave secreta"
                            : "Mostrar chave secreta"
                        }
                      >
                        {mostrarSecret ? "Ocultar" : "Mostrar"}
                      </button>

                      <button
                        type="button"
                        className="ca2fa-icon-button"
                        onClick={() => copiarTexto(secret)}
                      >
                        Copiar
                      </button>
                    </div>

                    <p>
                      Não compartilhe esta chave. Ela permite configurar
                      um autenticador para sua conta.
                    </p>
                  </div>
                )}

                <form
                  className="ca2fa-token-form"
                  onSubmit={handleEnable2FA}
                >
                  <label htmlFor="ca2fa-token">
                    Código do aplicativo autenticador
                  </label>

                  <input
                    id="ca2fa-token"
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    placeholder="Digite o código"
                    value={token2FA}
                    onChange={(e) =>
                      setToken2FA(e.target.value.replace(/\s/g, ""))
                    }
                    maxLength={12}
                    required
                    disabled={processando}
                  />

                  <button
                    type="submit"
                    className="ca2fa-button ca2fa-button-primary ca2fa-full-button"
                    disabled={processando || !token2FA.trim()}
                  >
                    {processando ? (
                      <>
                        <span className="ca2fa-spinner ca2fa-spinner-small" />
                        Validando...
                      </>
                    ) : (
                      "Confirmar e habilitar 2FA"
                    )}
                  </button>
                </form>

                {backupCodes.length > 0 && (
                  <div className="ca2fa-backup-box">
                    <div className="ca2fa-backup-heading">
                      <div>
                        <h3>Códigos de backup</h3>
                        <p>
                          Guarde-os em um local seguro e privado.
                        </p>
                      </div>

                      <button
                        type="button"
                        className="ca2fa-button ca2fa-button-secondary"
                        onClick={() =>
                          copiarTexto(backupCodes.join("\n"))
                        }
                      >
                        {copiado ? "Copiado!" : "Copiar códigos"}
                      </button>
                    </div>

                    <ul className="ca2fa-backup-list">
                      {backupCodes.map((code, index) => (
                        <li key={`${code}-${index}`}>
                          <code>{code}</code>
                        </li>
                      ))}
                    </ul>

                    <p className="ca2fa-security-note">
                      Esta tela contém informações sensíveis. Não a
                      compartilhe nem deixe aberta em um computador público.
                    </p>
                  </div>
                )}

                <button
                  type="button"
                  className="ca2fa-cancel-link"
                  onClick={cancelarConfiguracao}
                  disabled={processando}
                >
                  Cancelar configuração
                </button>
              </section>
            )}
          </>
        )}
      </div>

      {mostrarModalDesativar && (
        <div
          className="ca2fa-modal-overlay"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget && !processando) {
              setMostrarModalDesativar(false);
            }
          }}
        >
          <section
            className="ca2fa-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="ca2fa-modal-title"
          >
            <button
              type="button"
              className="ca2fa-modal-close"
              onClick={() => setMostrarModalDesativar(false)}
              disabled={processando}
              aria-label="Fechar janela"
            >
              ×
            </button>

            <div className="ca2fa-modal-icon">!</div>

            <h2 id="ca2fa-modal-title">
              Desabilitar autenticação em duas etapas?
            </h2>

            <p>
              Isso reduzirá a proteção adicional da sua conta. Para
              continuar, informe o código do seu aplicativo autenticador.
            </p>

            <form onSubmit={handleDisable2FA}>
              <label htmlFor="ca2fa-disable-token">
                Código de autenticação
              </label>

              <input
                id="ca2fa-disable-token"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                placeholder="Digite o código"
                value={tokenDesativar}
                onChange={(e) =>
                  setTokenDesativar(e.target.value.replace(/\s/g, ""))
                }
                maxLength={12}
                required
                disabled={processando}
                autoFocus
              />

              <div className="ca2fa-modal-actions">
                <button
                  type="button"
                  className="ca2fa-button ca2fa-button-secondary"
                  onClick={() => setMostrarModalDesativar(false)}
                  disabled={processando}
                >
                  Cancelar
                </button>

                <button
                  type="submit"
                  className="ca2fa-button ca2fa-button-danger"
                  disabled={processando || !tokenDesativar.trim()}
                >
                  {processando ? "Verificando..." : "Desabilitar"}
                </button>
              </div>
            </form>
          </section>
        </div>
      )}
    </div>
  );
};

export default Configuracoes2FA;
